// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1mBtx","title":"Header_title__1hjU2","left":"Header_left__3Hqtm","clinicName":"Header_clinicName__2Pep6"};